import React from "react";
import { IdentificationIcon } from "@heroicons/react/solid";

const PythonLogo = require("../assets/logos/PythonLogo.png");
const ReactLogo = require("../assets/logos/ReactLogo.png");
const JsLogo = require("../assets/logos/JsLogo.png");
const TailwindLogo = require("../assets/logos/TailwindLogo.png");
const SqlLogo = require("../assets/logos/SqlLogo.png");
const MongoDBLogo = require("../assets/logos/MongoDBLogo.png");
const NodeJSLogo = require("../assets/logos/NodeJSLogo.png");
const DockerLogo = require("../assets/logos/DockerLogo.png");
const RubyLogo = require("../assets/logos/ruby.png");
const phpLogo = require("../assets/logos/php.png");
const GolangLogo = require("../assets/logos/golang.png");
const awsLogo = require("../assets/logos/aws.png");
const html5Logo = require("../assets/logos/html5.png");
const GraphqlLogo = require("../assets/logos/graphql.png");
const LinuxLogo = require("../assets/logos/linux.png");

const About = () => {
  return (
    <div
      id="About"
      className="mx-12 mt-60 lg:mx-60 items-center justify-center lg:w-1/2 text-justify"
    >
      <div>
        <div className="table">
          <IdentificationIcon className="h-5 w-5 mr-4 text-yellow_vs" />{" "}
          <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
            About Me
          </code>
          <div className="table-cell border-b border-b-[#e6f1ff] border-opacity-25 w-full"></div>
        </div>
        <div className="text-[#a2aabc] text-lg mt-5">
          <code>
            I am a full stack developer with commercial experience since 2015,
            with most of my depth in backend engineering and AWS-based delivery.
            My core stack is PHP and Laravel, alongside JavaScript, TypeScript,
            and React. I am most effective when I can own features end to end,
            from early technical planning through to production release and
            support.
            <br />
            <br />
            My day-to-day work includes designing and maintaining Laravel
            services, building GraphQL APIs used in production, delivering safe
            data migrations, and operating background processing for long-running
            workflows. I focus on predictable delivery, low defect rates, and
            pragmatic technical decisions that keep systems maintainable over
            time.
            <br />
            <br />
            I also work across DevOps and infrastructure concerns where needed,
            including AWS Lambda integrations, CI/CD pipeline delivery, and
            improving automation. I care about test quality, thoughtful
            refactoring, and helping teams deliver consistently through clear
            code review and collaboration with QA and product.
          </code>
          <br />
          <br />
          <div className="grid grid-cols-3 gap-2 text-sm mt-5 text-brown_vs">
            <div className="flex flex-row mb-3">
              <img
                src={JsLogo}
                alt="Js Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>JavaScript (ES6+)</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={ReactLogo}
                alt="React Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>React</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={TailwindLogo}
                alt="Tailwind Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>Tailwind CSS</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={PythonLogo}
                alt="Python Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>Python</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={NodeJSLogo}
                alt="NodeJS Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>Node.js</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={SqlLogo}
                alt="SQL Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>SQL</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={MongoDBLogo}
                alt="MongoDB Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>MongoDB</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={DockerLogo}
                alt="Docker Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>Docker</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={RubyLogo}
                alt="Ruby Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>Ruby</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={phpLogo}
                alt="php Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>PHP</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={awsLogo}
                alt="aws Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>AWS</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={GolangLogo}
                alt="go Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>Golang</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={html5Logo}
                alt="html Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>HTML5</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={LinuxLogo}
                alt="linux Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>Linux</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={GraphqlLogo}
                alt="graphql Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>GraphQL</code>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <div className="table">
          <IdentificationIcon className="h-5 w-5 mr-4 text-yellow_vs" />{" "}
          <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
            Interests and Hobbies
          </code>
          <div className="table-cell border-b border-b-[#e6f1ff] border-opacity-25 w-full"></div>
        </div>
        <div className="text-[#a2aabc] text-lg mt-5">
          <code>
            Outside of work, I am quite hands on in how I spend my time and I
            tend to take ownership of the things I am involved in. One big part
            of that is football. I support Liverpool and I help run a
            supporters group, which means organising ticket allocations,
            managing payments, and coordinating people getting to games. What
            started as a social thing has grown into something that needs
            structure, planning, and clear communication, which I actually
            enjoy.
            <br />
            <br />
            I also enjoy competitive gaming, mainly FIFA and League of Legends.
            I like games that reward understanding systems, strategy, and
            continuous improvement. I am the type of person who wants to
            understand why something works, not just play it casually.
            <br />
            <br />
            Outside of that, I spend a lot of time outdoors. I regularly go
            walking in the Lake District and I have a converted Caddy camper,
            so I often head out with friends and my dog. I enjoy planning trips
            that are simple but thought through, and it is how I switch off and
            reset.
            <br />
            <br />
            Alongside all of that, I naturally tinker with technology and keep
            up to date with how things are moving. I like experimenting with
            new tools, understanding how they work, and applying them in
            practical ways. That curiosity and hands on approach is something I
            bring into my work as well.
          </code>
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};

export default About;
